var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tree',{staticClass:"form-item-container",staticStyle:{"max-height":"550px"},attrs:{"data":_vm.tree,"show-checkbox":"","check-strictly":true,"render":_vm.renderTree},on:{"on-check-change":_vm.onCheckChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }